<template>
    <div>
        <div class="popup_epst13">
            <div class="popup_wrap">
                <div class="title"><span class="t02">{{ waterQaInfo.facNm }}</span></div>
                <div class="pop_bt_close"><a href="#" class="self-close-btn">닫기</a></div>
                <div class="pop_table03">
                    <table>
                        <colgroup>
                            <col style="width:30%;">
                            <col>
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>설치장소</th>
                                <td>{{ waterQaInfo.address }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
        
                <div class="pop_table02">
                    <table>
                        <caption></caption>
                        <colgroup>
                            <col style="width:60%;">
                            <col style="">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th class="left">탁도(좋음 &lt; 0.5)</th>
                                <td class="left"><span>{{ waterQaInfo.tbValue }}</span> NTU</td>
                            </tr>
                            <tr>
                                <th class="left">pH(5.8 &lt; 좋음 &lt; 8.5)</th>
                                <td class="left"><span>{{ waterQaInfo.phValue }}</span> ph</td>
                            </tr>
                            <tr>
                                <th class="left">잔류염소(0.1 &lt; 좋음 &lt; 4.0)</th>
                                <td class="left"><span>{{ waterQaInfo.rcValue }}</span> mg/L</td>
                            </tr>
                            <tr>
                                <th class="left">전기전도도</th>
                                <td class="left"><span>{{ waterQaInfo.cdValue }}</span> ㎲/㎝</td>
                            </tr>
                            <tr>
                                <th class="left">수온</th>
                                <td class="left"><span>{{ waterQaInfo.teValue }}</span> ℃</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WaterQaInfoWin',
    data: function() {
        return {
            waterQaInfo: {}
        };
    },
    updated: function() {
        this.$emit('loaded-water-qa-info', this.$el.innerHTML);
    },
    methods: {
        setWaterQaInfo: function(waterQaInfo) {
            this.waterQaInfo =  Object.assign({}, waterQaInfo);
        }
    }
}
</script>